import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

const FullWidthImage = ({
  backgroundImage,
  imageMobile,
  imageDesktop,
  altText,
  onImageLoaded,
  children,
  isAbsolutePosition,
  className,
  loading,
  width,
  height,
}) => {
  const imageAltText = altText || 'full width image'
  const loadingType = loading || 'eager'
  return (
    <div
      className={cx('full-width-image__container', className, {
        '--is-absolute-position': !!isAbsolutePosition,
      })}
      style={{
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : null,
      }}
    >
      <picture onLoad={onImageLoaded} className="full-width-image__image">
        <source media="(max-width: 767px)" srcSet={imageMobile} />
        <source media="(min-width: 768px)" srcSet={imageDesktop} />
        <img
          src={imageDesktop}
          alt={imageAltText}
          loading={loadingType}
          width={width || 'auto'}
          height={height || 'auto'}
        />
      </picture>
      {children}
    </div>
  )
}

FullWidthImage.propTypes = {
  backgroundImage: PropTypes.string,
  imageMobile: PropTypes.string,
  imageDesktop: PropTypes.string,
  onImageLoaded: PropTypes.func,
  children: PropTypes.node,
  isAbsolutePosition: PropTypes.bool,
  className: PropTypes.string,
  altText: PropTypes.string,
  loading: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
}

export default FullWidthImage
